import React from "react";
import "primeicons/primeicons.css";
import PersonalDetailValueWrapper from "./PersonalDetailValue.style";
import { withTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { BUSINESS_LINE_COLORS, BUSINESS_LINE_PATHS } from "helpers/utils";

const PersonalDetailValue = ({ i18n, customerDetails }) => {
  const showRTL = i18n.dir() === "rtl";
  const { businessLine } = useParams();

  // REBRANDING COLORS
  let businessColor = BUSINESS_LINE_COLORS.DEFAULT;
  if (businessLine === BUSINESS_LINE_PATHS.BSF) businessColor = BUSINESS_LINE_COLORS.BSF;
  else if (businessLine === BUSINESS_LINE_PATHS.STC) businessColor = BUSINESS_LINE_COLORS.STC;
  else if (businessLine === BUSINESS_LINE_PATHS.LUCID) businessColor = BUSINESS_LINE_COLORS.LUCID;
  else if (businessLine === BUSINESS_LINE_PATHS.CARTRUST)
    businessColor = BUSINESS_LINE_COLORS.CARTRUST;
  else if (businessLine === BUSINESS_LINE_PATHS.SYARAH) businessColor = BUSINESS_LINE_COLORS.SYARAH;
  else if(businessLine === BUSINESS_LINE_PATHS.SNB) businessColor = BUSINESS_LINE_COLORS.SNB;
  else if(businessLine === BUSINESS_LINE_PATHS.ALNAGHI) businessColor = BUSINESS_LINE_COLORS.ALNAGHI;

  else if (businessLine === BUSINESS_LINE_PATHS.SNB) businessColor = BUSINESS_LINE_COLORS.SNB;
  else if (businessLine === BUSINESS_LINE_PATHS.PETROMIN)
    businessColor = BUSINESS_LINE_COLORS.PETROMIN;

  const userIconColorStyleObj = { color: businessColor, border: `1px solid ${businessColor}` };
  const iconColorStyleObj = { color: businessColor };

  return (
    <PersonalDetailValueWrapper>
      <div className={"personal-details-head " + (showRTL ? " ar" : "")}>
        <div className="col-12">
          <div className="row">
            <div className="col-xs-12 col-md-4 rborder">
              <div className="username">
                <i className="pi pi-user" style={userIconColorStyleObj}></i>
                <p>{i18n.t("PERSONAL_DETAIL.NAME")}</p>
              </div>
              <div className="name">
                <h4>
                  {i18n.language === "ar"
                    ? customerDetails?.araFullName ||
                      customerDetails?.araFirstName + " " + customerDetails?.araLastName
                    : customerDetails?.engFullName ||
                      customerDetails?.engFirstName + " " + customerDetails?.engLastName}
                </h4>
              </div>
            </div>
            <div className="col-xs-12 col-md-4 rborder">
              <div className="username">
                <i className="pi pi-credit-card" style={iconColorStyleObj}></i>
                <p>{i18n.t("PERSONAL_DETAIL.ID_NUMBER")}</p>
              </div>
              <div className="name">
                <h4 className="fm-tawuniya">{customerDetails?.idNumber ?? "N/A"}</h4>
              </div>
            </div>
            <div className="col-xs-12 col-md-4 last">
              <div className="username">
                <i className="pi pi-calendar" style={iconColorStyleObj}></i>
                <p>{i18n.t("PERSONAL_DETAIL.DOB")}</p>
              </div>
              <div className="name">
                <h4 className="fm-tawuniya">
                  {customerDetails?.gregDob?.replace(/-/g, "/") ?? "N/A"}
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PersonalDetailValueWrapper>
  );
};

export default withTranslation()(PersonalDetailValue);
